module.exports = __webpack_public_path__ + "img/sprint.97728e5e.svg";